import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseButtonSizeEnum } from '../../../base-button/base-button-size.enum';

@Component({
  selector: 'app-vb-payments-next-payment-by',
  templateUrl: './vb-payments-next-payment-by.component.html',
  styleUrls: ['./vb-payments-next-payment-by.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentsNextPaymentByComponent {
  @Input() nextPaymentDate: string = '';
  @Output() viewUpcomingPayments = new EventEmitter<void>();
  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
}
